import { Field, generateAttributeValidationRules } from './attributes';
import React, { useState } from 'react';
import { FormProvider } from '../common/form/FormContext';
import ValueEditor from './ValueEditor';
import { useBrowserOrAccountLocale } from '../common/hooks/useBrowserOrAccountLocale';
import AttributeEditorButtons from './AttributeEditorButtons';

type AttributeEditorProps = {
    fields: Field[];
    onSave: (value) => void;
    onCancel: () => void;
    initialValues?: object;
    saveButtonLabel?: string;
    enableValidationRules?: boolean;
};

export default (props: AttributeEditorProps) => {
    const { fields, onSave, onCancel, initialValues, saveButtonLabel, enableValidationRules } = props;
    const [value, setValue] = useState();
    const locale = useBrowserOrAccountLocale();
    const rules = enableValidationRules && generateAttributeValidationRules(fields, locale);

    return (
        <FormProvider
            validationRules={rules}
            state={value}
            setState={setValue}
            expandedSections={['attribute']}
            allowMultipleExpansion={false}
        >
            <ValueEditor fields={fields} initialValues={initialValues} />
            <AttributeEditorButtons onCancel={onCancel} saveButtonLabel={saveButtonLabel} onSave={onSave} />
        </FormProvider>
    );
};
